import { report_geofence_summary_kmService } from '../_services';

const state = { onRequest: false, report_geofence_summary_km: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        report_geofence_summary_kmService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    report_sync_geofence_summary_km({ dispatch, commit }, data) {
        commit('request');

        report_geofence_summary_kmService.report_sync_geofence_summary_km(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  report_geofence_summary_km: state => {
    return state.report_geofence_summary_km
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.report_geofence_summary_km = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.report_geofence_summary_km = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.report_geofence_summary_km = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const report_geofence_summary_kms = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
